<ion-content class="content" [fullscreen]="true">
  <div class="main-wrapper">
    <div class="padded">
      <div class="welcome-title" [innerHTML]="(isMobileView ? translations?.heroSection?.welcome_mobile : translations?.heroSection?.welcome) | safeHtml"></div>
      <app-video-section></app-video-section>
      <div class="centered-button-container">
        <a href="https://wa.me/17863409929" target="_blank" class="default-button" style="background-color: #25d366;">
          {{ translations?.heroSection?.pingMe }}
        </a>
      </div>
      <div class="pitch" [innerHTML]="(isMobileView ? translations?.heroSection?.pitch_mobile : translations?.heroSection?.pitch) | safeHtml"></div>
      <div class="centered-button-container">
        <a href="https://betocrypto.edugogo.ai" target="_blank" class="default-button">
          {{ translations?.header?.products }}
        </a>
      </div>
      <div class="tools-description">
        <ion-icon *ngIf="!isMobileView" name="sparkles-outline"></ion-icon>
          <span [innerHTML]="(isMobileView ? translations?.heroSection?.tools_mobile : translations?.heroSection?.tools) | safeHtml"></span>
        <ion-icon *ngIf="!isMobileView" name="sparkles-outline"></ion-icon>
      </div>
      <div class="centered-button-container">
        <a href="https://betocrypto.edugogo.ai" target="_blank" class="default-button" style="background-color: #38b6ff;">
          {{ translations?.heroSection?.cta }}
        </a>
      </div>
      <!--<div class="tools-description">
        <span [innerHTML]="(isMobileView ? translations?.heroSection?.transformYourMind_mobile : translations?.heroSection?.transformYourMind) | safeHtml"></span>
      </div>-->
    </div>
    
    <!--<div class="carousel-wrapper">
      <div #carousel class="carousel">
        <app-product-card
          *ngFor="let product of products; let i = index"
          [product]="product">
        </app-product-card>
      </div>-->
    
      <!-- Mobile-only buttons positioned below the product cards -->
      <!--<div class="mobile-nav-buttons" *ngIf="isMobileView">
        <button *ngIf="currentIndex > 0" (click)="scrollCarousel(-1)" class="nav-btn left-btn">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </button>
        <button *ngIf="currentIndex < products.length - 1" (click)="scrollCarousel(1)" class="nav-btn right-btn">
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </button>
      </div>
    </div>-->
    
    <div class="padded">
      <div class="pitch" [innerHTML]="(isMobileView ? translations?.heroSection?.ending_mobile : translations?.heroSection?.ending) |safeHtml"></div>
      <div class="calendar-section">
        <div [innerHTML]="(isMobileView ? translations?.calendarSection?.description_mobile : translations?.calendarSection?.description) | safeHtml"></div>
        <app-calendar></app-calendar>
      </div>
    </div>
  </div>
  <div>
    <app-pre-footer></app-pre-footer>
    <app-footer></app-footer>
  </div>
</ion-content>
